import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

/**
 * Hook to retrieve price/compare data with react-query
 * @param {string} stockCode
 * @param {boolean} [enabled=true]
 */
export function usePriceCompare(stockCode, enabled = true) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, isLoading, refetch } = useQuery(key, cb, {
    enabled: !!stockCode && enabled,
    staleTime: FIVE_MINUTES_MS,
    cacheTime: FIVE_MINUTES_MS,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { data, isSuccess, isLoading, refetch };
}
